<template>
  <div v-if="loading">
    <Loading />
  </div>
  <div class="content w-full">
    <TopNavbar />
    <div class="page-content">
      <template v-if="data">
        <HistoryInfo
          :appData="data"
          :defaultTab="defaultTab"
        />
      </template>
      <template v-else-if="isEmpty">
        <NotFoundContent :message="$t('Apps.notFound')" />
      </template>
    </div>
  </div>
  <NotificationComponent
    v-if="notification.show"
    :key="notification.key"
    :type="notification.type"
    :title="notification.title"
    :message="notification.message"
    @closed="!notification.show"
  />
</template>

<script>
import TopNavbar from "@/components/user/layout/TopNavbar.vue";
import AppOverviewComponent from "@/components/user/viewComponent/app/AppOverviewComponent.vue";
import Loading from "@/components/user/layout/LoadingComponent.vue";
import NotificationComponent from "@/components/custom/notifications/NotificationComponent.vue";
import NotFoundContent from "@/components/user/common/NotFoundContent.vue";
import { getAppHistory } from "@/api/history.api";
import HistoryInfo from "./HistoryInfo.vue";

export default {
  name: "HistoryViewComponen",
  components: {
    TopNavbar,
    AppOverviewComponent,
    HistoryInfo,
    Loading,
    NotificationComponent,
    NotFoundContent,
  },
  data() {
    return {
      historyId: this.$route.params.historyId,
      defaultTab: "overview",
      loading: false,
      data: null,
      isEmpty: false,
      notification: {
        show: false,
        key: 0,
        type: "",
        title: "",
        message: "",
      },
    };
  },
  async created() {
    this.loading = true;
    if (!this.historyId) return;
    try {
      await this.fetchHistory();
    } catch (error) {
      this.isEmpty = true;
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async fetchHistory() {
      this.loading = true;
      try {
        const response = await getAppHistory(this.historyId);
        if (response.data.status) {
          this.data = response.data.data.appData;
        }
      } catch (error) {
        this.isEmpty = true;
        this.showNotification(
          "error",
          this.$t("Custom.error"),
          error.response.data.msg
        );
      } finally {
        this.loading = false;
      }
    },
    showNotification(type, title, message) {
      this.notification = {
        show: true,
        key: Date.now(),
        type,
        title,
        message,
      };
    },
    toggleVisibility(visible) {
      this.$refs.dynamicVisibility.toggle(visible);
    },
  },
};
</script>
